import BillingRevenueReport from '../../../../templates/js/components/Cards/BillingRevenueReport.vue'

/**
 * Register billing-module Nova Vue cards.
 *
 * @param {import('vue').App} app
 */
const billingModuleSetup = (app) => {
  app.component('billing-revenue-report', BillingRevenueReport)
}

export { billingModuleSetup }
